import * as yup from 'yup'
import { AutocompleteValueSchema } from './AutocompleteValueSchema'

export const CarrierRelationshipsModalSchema = yup.object({
  /**
   * @example { id: '123', text: 'John Doe' }
   * */
  primaryManager: AutocompleteValueSchema.nullable(),
  /**
   * @example [{ id: '123', text: 'John Doe' }, { id: '456', text: 'Jane Doe'}]
   * */
  secondaryManagers: yup.array(AutocompleteValueSchema),
  /**
   * @example { id: '123', text: 'John Doe' }
   * */
  primaryExperienceRep: AutocompleteValueSchema.nullable(),
  /**
   * @example { id: '123', text: 'John Doe' }
   * */
  secondaryExperienceRep: AutocompleteValueSchema.nullable(),
  /**
   * @example { id: '123', text: 'John Doe' }
   * */
  primarySalesRep: AutocompleteValueSchema.nullable(),
  /**
   * @example [{ id: '123', text: 'John Doe' }, { id: '456', text: 'Jane Doe'}]
   * */
  secondarySalesReps: yup.array(AutocompleteValueSchema),
})

export type TCarrierRelationshipsModalSchema = yup.InferType<typeof CarrierRelationshipsModalSchema>
